export default function PresskitEditor({ content, longBioDraft, saving, onChange, onLongBioChange, onSubmit }) {
  return (
    <form className="admin-editor" onSubmit={onSubmit}>
      <div className="admin-editor-heading">
        <div>
          <p className="admin-kicker">Page content</p>
          <h2>Press Kit copy</h2>
          <p>Changes are published immediately. Separate long-bio paragraphs with a blank line.</p>
        </div>
        <a href="/presskit" target="_blank" rel="noopener noreferrer">View page</a>
      </div>
      <label>Kicker<input value={content.kicker} onChange={(event) => onChange("kicker", event.target.value)} required /></label>
      <label>Page title<input value={content.title} onChange={(event) => onChange("title", event.target.value)} required /></label>
      <label>Introduction<textarea rows="4" value={content.intro} onChange={(event) => onChange("intro", event.target.value)} required /></label>
      <label>Short bio<textarea rows="10" value={content.shortBio} onChange={(event) => onChange("shortBio", event.target.value)} required /></label>
      <label>Long bio paragraphs<textarea rows="22" value={longBioDraft} onChange={(event) => onLongBioChange(event.target.value)} required /></label>
      <button className="admin-primary" disabled={saving}>{saving ? "Publishing…" : "Publish Press Kit"}</button>
    </form>
  );
}
